import * as StateLib from "@/Utils/StateLib";
import { ToolIcon } from "@theorgchartdev/storybook";
import React from "react";
import { getHoverTipContent } from "@/Utils/Misc";
import { appstr } from "@coreapp/utils/appstr";
import { QAlert } from "@coreapp/CoreApp/QAlert";
import {
  gSupportPortal,
  gSupportMsgKey,
  gUseGenericSupportContact
} from "@coreapp/whitelabel/brand";
import { enumWidgetTrigger } from "@coreapp/CoreApp/widgets/widgetTypes";

const HelpMenu = () => {
  const handleHelpClick = () => {
    const wsMgr = StateLib.GetWSMgr();
    const widgetMgr = wsMgr?.GetWidgetMgr();
    if (!widgetMgr?.ActivateWidget(enumWidgetTrigger.help)) {
      handleSupport(wsMgr);
    }
  };

  const handleSupport = wsMgr => {
    if (gUseGenericSupportContact) {
      if (!wsMgr) return;
      const alert = new QAlert();
      alert.InitAlert(appstr("Help"), appstr(gSupportMsgKey), null, wsMgr);
      return;
    }
    window.open(gSupportPortal);
  };

  return (
    <ToolIcon
      name={"circle-question"}
      title={"Help"}
      size="medium"
      shape={"round"}
      tooltipProps={getHoverTipContent("Help menu")}
      aria-label={"Help menu"}
      data-testid="header-help-btn"
      onClick={handleHelpClick}
    />
  );
};

export default HelpMenu;
